import React, { useEffect, useState } from "react";
import { supabase, isSupabaseConfigured } from "../lib/supabase";

export default function AdminLogin() {
  const [form, setForm] = useState({
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const [checkingSession, setCheckingSession] = useState(true);
  const [message, setMessage] = useState("");

  useEffect(() => {
    checkExistingSession();
  }, []);

  async function checkExistingSession() {
    try {
      if (!isSupabaseConfigured || !supabase) {
        setMessage("Supabase n'est pas configuré.");
        return;
      }

      const {
        data: { session },
      } = await supabase.auth.getSession();

      if (session?.user) {
        window.location.href = "/admin/factures";
        return;
      }
    } catch (error) {
      console.error(error);
      setMessage("Erreur lors de la vérification de la session.");
    } finally {
      setCheckingSession(false);
    }
  }

  function updateField(field, value) {
    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  }

  async function handleLogin(e) {
    e.preventDefault();

    try {
      setLoading(true);
      setMessage("");

      if (!isSupabaseConfigured || !supabase) {
        setMessage("Supabase n'est pas configuré.");
        return;
      }

      const { data, error } = await supabase.auth.signInWithPassword({
        email: form.email,
        password: form.password,
      });

      if (error) {
        setMessage(error.message || "Connexion impossible.");
        return;
      }

      if (!data?.user) {
        setMessage("Connexion impossible.");
        return;
      }

      const { data: adminRow, error: adminError } = await supabase
        .from("app_admins")
        .select("id, user_id")
        .eq("user_id", data.user.id)
        .maybeSingle();

      if (adminError) {
        setMessage("Connexion réussie, mais vérification admin impossible.");
        return;
      }

      if (!adminRow) {
        await supabase.auth.signOut();
        setMessage("Accès refusé : ce compte n'est pas administrateur.");
        return;
      }

      window.location.href = "/admin/factures";
    } catch (error) {
      console.error(error);
      setMessage("Une erreur est survenue pendant la connexion.");
    } finally {
      setLoading(false);
    }
  }

  if (checkingSession) {
    return (
      <div style={styles.page}>
        <div style={styles.card}>
          <h1 style={styles.title}>Connexion administrateur</h1>
          <p>Chargement...</p>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.title}>Connexion administrateur</h1>
        <p style={styles.subtitle}>
          Connecte-toi avec ton compte admin pour accéder aux factures.
        </p>

        {message ? (
          <div style={styles.alert}>
            {message}
          </div>
        ) : null}

        <form onSubmit={handleLogin}>
          <div style={styles.field}>
            <label style={styles.label}>Email</label>
            <input
              type="email"
              value={form.email}
              onChange={(e) => updateField("email", e.target.value)}
              style={styles.input}
              placeholder="admin@weblax.fr"
              required
            />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Mot de passe</label>
            <input
              type="password"
              value={form.password}
              onChange={(e) => updateField("password", e.target.value)}
              style={styles.input}
              placeholder="••••••••"
              required
            />
          </div>

          <button type="submit" style={styles.button} disabled={loading}>
            {loading ? "Connexion..." : "Se connecter"}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#0b1020",
    padding: "20px",
    color: "#fff",
  },
  card: {
    width: "100%",
    maxWidth: "460px",
    background: "#121933",
    border: "1px solid rgba(255,255,255,0.08)",
    borderRadius: "18px",
    padding: "28px",
    boxShadow: "0 12px 40px rgba(0,0,0,0.25)",
  },
  title: {
    fontSize: "1.9rem",
    fontWeight: 700,
    marginBottom: "8px",
  },
  subtitle: {
    color: "rgba(255,255,255,0.75)",
    marginBottom: "20px",
  },
  field: {
    display: "flex",
    flexDirection: "column",
    marginBottom: "16px",
  },
  label: {
    marginBottom: "8px",
    fontSize: "0.95rem",
  },
  input: {
    padding: "12px 14px",
    borderRadius: "10px",
    border: "1px solid rgba(255,255,255,0.12)",
    background: "#0d1430",
    color: "#fff",
    outline: "none",
  },
  button: {
    width: "100%",
    padding: "12px 16px",
    borderRadius: "10px",
    border: "none",
    background: "#4f7cff",
    color: "#fff",
    fontWeight: 700,
    cursor: "pointer",
    marginTop: "10px",
  },
  alert: {
    background: "rgba(255, 87, 87, 0.12)",
    border: "1px solid rgba(255, 87, 87, 0.3)",
    borderRadius: "12px",
    padding: "12px 14px",
    marginBottom: "16px",
  },
};